<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        title="Tạo điểm danh/nhận xét"
        width="40%"
    >
      <div>
        <el-row>
          <el-col :span="10">
            <el-date-picker
                style="width: 250px"
                size="small"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="true"
            ></el-date-picker>
          </el-col>
          <el-col :span="10">
            <el-row type="flex" :gutter="10">
              <el-col :span="12">
                <el-button
                    size="small"
                    :loading="isLoading.attendance"
                    @click="createAttendanceEvaluateManual('attendanceType')"
                    type="primary"
                >
                  Tạo điểm danh
                </el-button>
              </el-col>

              <el-col :span="12">
                <el-button
                    size="small"
                    :loading="isLoading.evaluate"
                    @click="createAttendanceEvaluateManual('evaluateType')"
                    type="primary"
                >
                  Tạo nhận xét ngày
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <div slot="footer">
        <div>
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      isLoading: {
        attendance: false,
        evaluate: false,
      },

      dataInput: {
        date: ""
      }
    }
  },
  watch: {},
  methods: {
    handleClose() {
      this.$emit("closeDialog", "attendance_and_comments");
      this.resetData();
    },

    resetData() {
      this.dataInput.date = "";
    },

    createAttendanceEvaluateManual(type) {
      let typeText = type === "attendanceType" ? "ĐIỂM DANH" : "NHẬN XÉT";
      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày tạo " + typeText,
          type: "error",
        });
        throw null;
      }
      this.$confirm(
          "Bạn có chắc chắn muốn tạo " + typeText + " không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        type === "attendanceType" ? this.isLoading.attendance = true : this.isLoading.evaluate = true;
        OtherService.createAttendanceEvaluateRootFromDateForSupperPlus(type, this.dataInput)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.attendance = false;
              this.isLoading.evaluate = false;
            });
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>